import * as React from 'react';
import { Box, Text } from '@awning/components';
import { useRentEstimatorStore } from './store';
import { capitalize, pluralize } from '../utils';

const Heading = React.memo(() => {
  const {
    address,
    modelParams: { bathrooms, bedrooms, property_type },
  } = useRentEstimatorStore(state => ({
    address: state.address,
    modelParams: state.modelParams,
  }));
  const propertyType = property_type.split('_').map(capitalize).join(' ');

  return (
    <Box sx={{ marginTop: 5 }}>
      <Text sx={{ text: 'xs', color: 'gray.400' }}>Rent estimate for</Text>
      <Text
        sx={{
          display: 'block',
          fontWeight: 'bold',
          textOverflow: 'ellipsis',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          color: 'gray.600',
          marginTop: 2,
        }}
      >
        {address}
      </Text>
      <Box sx={{ text: 'sm', color: 'gray.600', marginTop: 1 }}>
        <Text>
          {bedrooms} {pluralize(bedrooms, 'Bedroom')}
        </Text>
        <Text sx={{ color: 'gray.400', paddingX: 1 }}>•</Text>
        <Text>
          {bathrooms} {pluralize(bathrooms, 'Bath')}
        </Text>
        <Text sx={{ color: 'gray.400', paddingX: 1 }}>•</Text>
        <Text>{propertyType}</Text>
      </Box>
    </Box>
  );
});

export default Heading;
